import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

const LoginIllustration = forwardRef(({ sx, ...other }, ref) => (
  <Box
    ref={ref}
    component="svg"
    width="100%"
    height="100%"
    viewBox="0 0 480 360"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ ...sx }}
    {...other}
  >
    <defs>
      <linearGradient id="BG1" x1="19.667%" x2="77.639%" y1="14.717%" y2="85.764%">
        <stop offset="0%" stopColor="#FF6B6B" />
        <stop offset="100%" stopColor="#FF8E8E" />
      </linearGradient>
      <linearGradient id="BG2" x1="19.667%" x2="77.639%" y1="14.717%" y2="85.764%">
        <stop offset="0%" stopColor="#4A90E2" />
        <stop offset="100%" stopColor="#6BA7E8" />
      </linearGradient>
    </defs>

    {/* Camera Body */}
    <path
      fill="#2C3E50"
      d="M240 120c-66.3 0-120 53.7-120 120s53.7 120 120 120 120-53.7 120-120-53.7-120-120-120zm0 220c-55.2 0-100-44.8-100-100s44.8-100 100-100 100 44.8 100 100-44.8 100-100 100z"
    />

    {/* Camera Lens */}
    <circle cx="240" cy="240" r="60" fill="#34495E" />
    <circle cx="240" cy="240" r="40" fill="#2C3E50" />
    <circle cx="240" cy="240" r="20" fill="#1ABC9C" />

    {/* Camera Flash */}
    <rect x="220" y="80" width="40" height="20" rx="5" fill="#E74C3C" />

    {/* Film Reel */}
    <circle cx="160" cy="240" r="15" fill="#7F8C8D" />
    <circle cx="320" cy="240" r="15" fill="#7F8C8D" />

    {/* Film Strip */}
    <rect x="175" y="230" width="90" height="20" fill="#95A5A6" />
    <rect x="175" y="230" width="90" height="4" fill="#7F8C8D" />
    <rect x="175" y="246" width="90" height="4" fill="#7F8C8D" />

    {/* Media Icons */}
    <g transform="translate(200, 280)">
      <rect x="0" y="0" width="20" height="20" rx="4" fill="#3498DB" />
      <rect x="30" y="0" width="20" height="20" rx="4" fill="#E74C3C" />
      <rect x="60" y="0" width="20" height="20" rx="4" fill="#2ECC71" />
    </g>

    {/* Decorative Elements */}
    <circle cx="120" cy="120" r="20" fill="url(#BG1)" opacity="0.6" />
    <circle cx="360" cy="120" r="20" fill="url(#BG2)" opacity="0.6" />
  </Box>
));

LoginIllustration.propTypes = {
  sx: PropTypes.object,
};

export default LoginIllustration; 